import React from 'react';
import { BookOpen, Gauge, KeyRound, PieChart } from 'lucide-react';
import PillTabs from '../../../../components/common/PillTabs';
import { useGovernedMcp } from '../governedMcpStore';
import ApiKeysTab from './ApiKeysTab';
import QuotaGuideTab from './QuotaGuideTab';
import QuotasSpendingsTab from './QuotasSpendingsTab';
import UsageStatisticsTab from './UsageStatisticsTab';

const SECTIONS = [
  { id: 'statistics' as const, label: 'Statistics', icon: PieChart },
  { id: 'api-keys' as const, label: 'API Keys', icon: KeyRound },
  { id: 'quotas' as const, label: 'Quotas & Spendings', icon: Gauge },
  { id: 'guide' as const, label: 'Guide', icon: BookOpen },
];

export default function AiUsageLimitsTab({
  isLight,
  onToast,
}: {
  isLight: boolean;
  onToast: (type: 'success' | 'error' | 'info', message: string) => void;
}) {
  const { state, setUsageSection } = useGovernedMcp();
  const section = state.usageSection;

  return (
    <div className="space-y-5">
      <PillTabs
        isLight={isLight}
        ariaLabel="AI usage sections"
        value={section}
        items={SECTIONS}
        onChange={setUsageSection}
      />
      <div className="min-w-0">
        {section === 'statistics' ? <UsageStatisticsTab isLight={isLight} /> : null}
        {section === 'api-keys' ? <ApiKeysTab isLight={isLight} onToast={onToast} /> : null}
        {section === 'quotas' ? <QuotasSpendingsTab isLight={isLight} onToast={onToast} /> : null}
        {section === 'guide' ? <QuotaGuideTab isLight={isLight} /> : null}
      </div>
    </div>
  );
}
